import { render } from "./Scholar.vue?vue&type=template&id=6c271b3c&scoped=true"
import script from "./Scholar.vue?vue&type=script&lang=js"
export * from "./Scholar.vue?vue&type=script&lang=js"

import "./Scholar.vue?vue&type=style&index=0&id=6c271b3c&scoped=true&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\cymcorp-site\\dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c271b3c"]])

export default __exports__